import React, { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';
import * as jobsActions from '../../Redux/Actions/jobs';
import { toastMessage } from '../../utils/toast';

const ReferenceStatusModal = ({ t, showModal, loading, handleCancel, referenceEditData, footerOption1, footerOption2 }) => {
 
    const [receiptNo, setReceiptNo] = useState('');
    const [refAmount, setRefAmount] = useState('');
    const [actAmount, setActAmount] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);

    useEffect(()=> {
        setReceiptNo(referenceEditData && referenceEditData.receiptNumber);
        setRefAmount(referenceEditData && referenceEditData.payableAmount);
        setActAmount(referenceEditData && referenceEditData.paymentDetails && referenceEditData.actualAmount);
    }, [referenceEditData]);

    const statusHandler = (status) => {
        setButtonLoading(true);
            let payload = {
                referenceId: referenceEditData && referenceEditData.id,
                status: status ? 'Approved': 'Rejected'
            };
            jobsActions.updateReferenceStatusModel(payload).then(res => {
                if(res && res.data){
                   toastMessage('success', 'Status changed successfully.');
                   setButtonLoading(false);
                   handleCancel();
                   window.location.reload();  
                }else{
                    setButtonLoading(false);
                    toastMessage('error', (res && res.message) || 'Try again later');
                }
            }).catch(err => {
                setButtonLoading(false);
                toastMessage('error', (err && err.message) || 'Try again later');
            });
    }

    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.updateReferenceStatus.title")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column mb-3">
                                <label className="form-label mb-1">{t("jobsManagement.infoJob.references.actualAmount")}</label> 
                                <label className="form-label mb-1">{actAmount}</label>
                            </div>
                            <div className="d-flex flex-column mb-3">
                                <label className="form-label mb-1">{t("jobsManagement.infoJob.references.payableAmount")}</label>
                                <label className="form-label mb-1">{refAmount ? refAmount : 0 }</label>
                            </div>
                            <div className="d-flex flex-column mb-3">
                                <label className="form-label mb-1">{t("jobsManagement.infoJob.references.receiptNo")}</label>
                                <label className="form-label mb-1">{receiptNo}</label>
                            </div>
                            {t("jobsManagement.infoJob.updateReferenceStatus.closeTransaction")}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={loading || buttonLoading} onClick={()=>{statusHandler(false)}}>{footerOption2 ? footerOption2 :t("jobsManagement.infoJob.createReference.reject")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || buttonLoading} onClick={()=> {statusHandler(true)}}>
                                {footerOption1 ? footerOption1 :t("jobsManagement.infoJob.createReference.approve")} {(loading || buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default ReferenceStatusModal;
